import { render } from "./Page.vue?vue&type=template&id=099c5115&scoped=true&ts=true"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"

import "./Page.vue?vue&type=style&index=0&id=099c5115&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099c5115"]])

export default __exports__